<template>
  <div class="invoice-alter">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>Exhibiting</BreadcrumbItem>
          <BreadcrumbItem>Invoice</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.nameEn}}</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="$router.push('/exhibitionEn/index/exinfo/invoice');">
          <span>Back</span>
        </div>
      </div>
    </div>
    
    <div class="invoice-alter-content" v-if="invoiceDownInfo">
      <Form
        ref="formInline"
        :model="formInline"
        label-position="right"
        :label-width="225"
        @submit.native.prevent
      >
        <FormItem label="Submission time：">
          <p class="alter-p">{{invoiceDownInfo.changeTime | moment("YYYY/MM/DD HH:mm:ss")}}</p>
        </FormItem>
        <FormItem label="Review status：">
          <p class="alter-p">Pending</p>
        </FormItem>
        <!-- <FormItem label="操作状态：">
          <p class="alter-p">修改</p>
        </FormItem> -->
        <FormItem label="Invoice title：">
          <p class="alter-p" :style="tag || tagTitle? 'color:red':''">{{invoiceDownInfo.title}}</p>
        </FormItem>
        <FormItem label="Tax registration number：">
          <p class="alter-p" :style="tag || tagCode? 'color:red':''">{{invoiceDownInfo.code}}</p>
        </FormItem>
        <FormItem label="Bank name：">
          <p class="alter-p" :style="tag || tagBank? 'color:red':''">{{invoiceDownInfo.bank}}</p>
        </FormItem>
        <FormItem label="Account number：">
          <p class="alter-p" :style="tag || tagBankAccount? 'color:red':''">{{invoiceDownInfo.bankAccount}}</p>
        </FormItem>
        <FormItem label="Registered address：">
          <p class="alter-p" :style="tag || tagAddress? 'color:red':''">{{invoiceDownInfo.address}}</p>
        </FormItem>
        <FormItem label="Registered telephone number：">
          <p class="alter-p" :style="tag || tagTel? 'color:red':''">{{invoiceDownInfo.tel}}</p>
        </FormItem>
      </Form>
      <Button style="position:absolute;top:30px;right:30px;" @click="$router.push('/exhibitionEn/index/exinfo/invoice-alter-edit')">Edit</Button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "exhibition-info-fasciaBoardAlter",
  data() {
    return {
      formInline: {
        // form双向绑定
        Title: "", // 发票抬头
        // InvoiceType: "1", // 1:企业增值税普通发票 2:增值税专用发票
        Code: "", // 税务登记证号(纳税人识别号)
        BankName: "", // 开户银行名称
        BankNumber: "", // 开户银行账号
        Address: "", // 注册场所地址
        Tel: "" // 注册固定电话
      },
      invoiceInfo: null,
      invoiceDownInfo: null,
      tag: false,
      tagTitle: false,
      tagCode: false,
      tagBank: false,
      tagBankAccount: false,
      tagAddress: false,
      tagTel: false,
    };
  },
  computed: {
    ...mapGetters({
      joinInfo: "loginModule/getJoinInfo",
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    }),
    exhibitionId() {
      return this.exhibition.id;
    }
  },
  async created() {
    document.title = "国际焙烤展 - Invoice";
    // 获取发票信息
    let res = await this.getInvoice(this.joinInfo.joinId);
    if (res) {
      this.invoiceInfoIsHave = true;
      this.invoiceInfo = res;
      this.formInline.Title = res.title;
      this.formInline.Code = res.code;
      this.formInline.BankName = res.bank;
      this.formInline.BankNumber = res.bankAccount;
      this.formInline.Address = res.address;
      this.formInline.Tel = res.tel;
    } else {
      this.tag = true;
    }
    // 获取发票修改记录
    let result = await this.getInvoiceDown(this.joinInfo.joinId);
    if (result) {
      this.invoiceDownInfo = result;
    }

    if (this.invoiceInfo) {
      if (this.invoiceInfo.title !== this.invoiceDownInfo.title) {
        this.tagTitle = true;
      }
      if (this.invoiceInfo.code !== this.invoiceDownInfo.code) {
        this.tagCode = true;
      }
      if (this.invoiceInfo.bank !== this.invoiceDownInfo.bank) {
        this.tagBank = true;
      }
      if (this.invoiceInfo.bankAccount !== this.invoiceDownInfo.bankAccount) {
        this.tagBankAccount = true;
      }
      if (this.invoiceInfo.address !== this.invoiceDownInfo.address) {
        this.tagAddress = true;
      }
      if (this.invoiceInfo.tel !== this.invoiceDownInfo.tel) {
        this.tagTel = true;
      }
    } 
  },
  methods: {
    ...mapActions({
      getInvoice: "exhibitionModule/getInvoice",
      getInvoiceDown: "exhibitionModule/getInvoiceDown",
    }),
  }
};
</script>

<style lang="scss">
.invoice-alter {
  .ivu-form-item {
    margin-bottom: 0;
  }
}
</style>
<style scoped lang="scss">
.invoice-alter {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 800px;
    margin: 30px;
    padding: 40px;
    min-height: 500px;
    background: #fff;
    padding-bottom: 190px;
    position: relative;
  }
  .alter-p {
    line-height: 34px;
  }
}
</style>
